import { forwardRef, InjectionToken } from '@angular/core';
import { LanguagesService } from './languages.service';

export interface ILanguagesService extends LanguagesService {}

/** @deprecated use LanguagesService instead */
export const LanguagesServiceToken = new InjectionToken<ILanguagesService>('LanguagesService');

/** @deprecated use LanguagesService instead */
export const LanguagesServiceProvider = {
	provide: LanguagesServiceToken,
	useExisting: forwardRef(() => LanguagesService)
};